<template>
    <a :href="`${possibleLangPrefix}/blog/${content.slug}`" class="flex flex-col w-full | block-img-hover">
        <div class="relative">
            <div class="aspect-w-7 aspect-h-4 w-full"></div>
            <div class="absolute w-full h-full top-0 left-0">
                <picture class="absolute w-full h-full top-0 left-0" v-if="content.acf.preview_image">
                    <img :data-src="content.acf.preview_image.url" :alt="content.acf.preview_image.title" class="w-full h-full object-cover lazyload" />

                    <div class="block-img-hover__icon">
                        <i class="fa-regular fa-arrow-right"></i>
                    </div>
                </picture>
            </div>
        </div>

        <div class="mt-md">
            <h3 v-html="content.title.rendered"></h3>

            <div class="mt-sm flex items-center justify-start gap-xs flex-wrap">
                <span v-for="(cat, index) in content.categories_objects" :key="index" v-html="cat.name" class="py-xxs px-xs text-xs uppercase text-gray-500 border border-gray-600 text-opacity-80 tracking-[2px] font-semibold"> </span>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: 'blogdetail',
    props: ['content'],

    computed: {
        possibleLangPrefix() {
            // prefix with lang other than nl for correct Weglot translations
            return document.documentElement.lang !== 'nl' ? `/${document.documentElement.lang}` : '';
        },
    },
};
</script>
